import React from 'react';
import { FadeIn } from './ui/FadeIn';
import { XCircle } from 'lucide-react';
export function FailedApproachesSection() {
  const approaches = [{
    title: 'El "interrogatorio policial"',
    desc: 'Preguntar sobre lo que hicieron con su madre solo genera desconfianza y ganas de ponerse los cascos.'
  }, {
    title: 'Los regalos y sobornos',
    desc: 'Crean una relación transaccional donde tu valor depende de lo que compras, no de quién eres.'
  }, {
    title: 'Forzar la alegría inmediata',
    desc: 'Ignora que ellos necesitan "descomprimir" el estrés del intercambio de custodia.'
  }, {
    title: 'Dar espacio excesivo',
    desc: 'Por miedo al conflicto termina convirtiéndote en un "padre de visita" invisible.'
  }];
  return <section className="py-16 md:py-24 px-4 bg-white" data-id="element-13">
      <div className="max-w-2xl mx-auto" data-id="element-14">
        <FadeIn data-id="element-15">
          <h2 className="text-3xl md:text-4xl font-bold mb-10 text-center" data-id="element-16">
            Por qué lo que has intentado no funciona
          </h2>
          <div className="space-y-6" data-id="element-17">
            {approaches.map((item, idx) => <div key={idx} className="flex items-start gap-4" data-id="element-18">
                <XCircle className="w-6 h-6 text-red-700 flex-shrink-0 mt-1" data-id="element-19" />
                <div data-id="element-20">
                  <h3 className="text-xl font-bold mb-2" data-id="element-21">{item.title}</h3>
                  <p className="text-lg text-brand-gray/80" data-id="element-22">{item.desc}</p>
                </div>
              </div>)}
          </div>
        </FadeIn>
      </div>
    </section>;
}